import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"
import { AuthGuard } from "./auth/auth.guard"
import { MasterGuard } from "./auth/master.guard"
import { RoleGuard } from "./auth/role.guard"
import { Role } from "./models/role"
import { ConfigComponent } from "./config/config.component"
import { PageNotAuthorizedComponent } from "./page-not-authorized/page-not-authorized.component"
import { MenuComponent } from './config/menu/menu.component';
import { NuevoMenuComponent } from './config/menu/nuevo/nuevo-menu.component';
import { AreaFuncionalGuard } from './auth/areas-funcionales.guard';
import { EditingMenuComponent } from './config/menu/editing/editing-menu.component';
import { DestinatariosComponent } from './config/destinatarios/destinatarios.component';
import { DestinatarioComponent } from './config/destinatarios/destinatario/destinatario.component';
import { DestinatariosMenuComponent } from './config/menu/destinatarios/destinatarios-menu.component';
import { FeriadosComponent } from "./config/feriados/feriados.component"
import { AsistenteChatComponent } from "./config/asistente-chat/asistente-chat.component"
import { GestionDestinatarioComponent } from "./config/gestion-destinatario/gestion-destinatario.component"
import { EditarDestinatarioComponent } from "./config/gestion-destinatario/editar-destinatario/editar-destinatario.component"
import { AsistenteFormularioComponent } from "./config/asistente-formulario/asistente-formulario.component"
import { AsistenteMenuComponent } from "./config/asistente-menu/asistente-menu.component"
import { ValidacionComponent } from './config/validaciones/validacion/validacion.component';
import { ValidacionesComponent } from './config/validaciones/validaciones.component';
import { ValidacionesMenuComponent } from './config/menu/validaciones/validaciones-menu.component';

const configRoutes: Routes = [
    {
        path: 'home',
        component: MenuComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard, AreaFuncionalGuard] }
    },
    {
        path: 'config/asistentemenu',
        component: AsistenteMenuComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'edit',
        component: EditingMenuComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'menu',
        component: ConfigComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'destinatarios',
        component: DestinatariosComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'destinatario',
        component: DestinatarioComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'validaciones',
        component: ValidacionesComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'validacion',
        component: ValidacionComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'feriados',
        component: FeriadosComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'config/asistentechat',
        component: AsistenteChatComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'config/asistenteformulario',
        component: AsistenteFormularioComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'gestiondestinatario',
        component: GestionDestinatarioComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },

    {
        path: 'editar-destinatario/:id',
        component: EditarDestinatarioComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },

    {
        path: 'menudestinatarios',
        component: DestinatariosMenuComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    {
        path: 'menuvalidaciones',
        component: ValidacionesMenuComponent,
        canActivate: [MasterGuard],
        data: { roles: [Role.Admin, Role.MenuConfigurator, Role.MenuAdministrator], guards: [AuthGuard, RoleGuard] }
    },
    
    {
        path: 'not-authorized',
        component: PageNotAuthorizedComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(configRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class ConfigRoutingModule { }